import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ESIM_SALE_KEY } from './esimOrderState';
import { EsimSuccess } from './EsimSuccess';
import { useEsimOrder } from './useEsimOrder';

export const EsimOrderPage: React.FC = () => {
  const { saleId = '' } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const plansPath = location.pathname.startsWith('/store/india-esim') ? '/store/india-esim' : '/store/canada-esim';
  const phase = useEsimOrder(saleId);

  useEffect(() => {
    const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
    if (nav?.type === 'reload') {
      sessionStorage.removeItem(ESIM_SALE_KEY);
      navigate(plansPath, { replace: true, state: { openLatestPending: true } });
      return;
    }
    if (saleId) sessionStorage.setItem(ESIM_SALE_KEY, saleId);
  }, [navigate, plansPath, saleId]);

  if (phase.kind === 'loading') {
    return <main className="cwy-esim-theme canada-esim"><p className="esim-lede">Loading your order…</p></main>;
  }
  if (phase.kind === 'not-found') {
    return (
      <main className="cwy-esim-theme canada-esim">
        <h1>Order not found</h1>
        <button type="button" className="esim-btn" onClick={() => navigate(plansPath)}>Back to plans</button>
      </main>
    );
  }
  if (phase.kind === 'network') {
    return (
      <main className="cwy-esim-theme canada-esim">
        <h1>Could not load this order</h1>
        <button type="button" className="esim-btn" onClick={phase.retry}>Retry</button>
      </main>
    );
  }

  const kind = phase.kind === 'sorting' ? 'sorting' : phase.kind;
  return (
    <EsimSuccess
      kind={kind}
      order={phase.order}
      message={phase.kind === 'sorting' ? phase.message : undefined}
      onBuyAnother={() => {
        sessionStorage.removeItem(ESIM_SALE_KEY);
        navigate(plansPath, { state: { openLatestReady: true } });
      }}
    />
  );
};
